/**
 * One filter in the candidate list's filter panel (DEV-3543). The broker picks
 * which of these the panel shows; a filter can hold more than one criteria
 * field (occupants holds two, the start date holds a direction and a date).
 */
export var EApplicationFilter;
(function (EApplicationFilter) {
    EApplicationFilter["Income"] = "income";
    EApplicationFilter["RentMatchScore"] = "rentMatchScore";
    EApplicationFilter["Occupants"] = "occupants";
    EApplicationFilter["Applications"] = "applications";
    EApplicationFilter["Rating"] = "rating";
    EApplicationFilter["Pets"] = "pets";
    EApplicationFilter["StartDate"] = "startDate";
    EApplicationFilter["DocumentsComplete"] = "documentsComplete";
    EApplicationFilter["NoNoShowsElsewhere"] = "noNoShowsElsewhere";
})(EApplicationFilter || (EApplicationFilter = {}));
